"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var idlUtils = require("../generated/utils");

var HTMLElement = require("../generated/HTMLElement");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../helpers/node"),
    nodeRoot = _require.nodeRoot;

var _require2 = require("../helpers/shadow-dom"),
    assignSlotableForTree = _require2.assignSlotableForTree,
    findFlattenedSlotables = _require2.findFlattenedSlotables;

var HTMLSlotElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLSlotElementImpl, _HTMLElementImpl);

  function HTMLSlotElementImpl(globalObject, args, privateData) {
    var _this;

    _classCallCheck(this, HTMLSlotElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLSlotElementImpl).call(this, globalObject, args, privateData));
    _this._assignedNodes = [];
    return _this;
  } // https://dom.spec.whatwg.org/#slot-name


  _createClass(HTMLSlotElementImpl, [{
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      _get(_getPrototypeOf(HTMLSlotElementImpl.prototype), "_attrModified", this).call(this, name, value, oldValue); // https://dom.spec.whatwg.org/#slot-name


      if (name === "name") {
        if (value === oldValue) {
          return;
        }

        if (value === null && oldValue === "") {
          return;
        }

        if (value === "" && oldValue === null) {
          return;
        }

        assignSlotableForTree(nodeRoot(this));
      }
    } // https://html.spec.whatwg.org/#dom-slot-assignednodes

  }, {
    key: "assignedNodes",
    value: function assignedNodes(options) {
      if (!options || !options.flatten) {
        return this._assignedNodes.map(idlUtils.wrapperForImpl);
      }

      return findFlattenedSlotables(this).map(idlUtils.wrapperForImpl);
    } // https://html.spec.whatwg.org/#dom-slot-assignedelements

  }, {
    key: "assignedElements",
    value: function assignedElements(options) {
      return this.assignedNodes(options).filter(HTMLElement.is);
    }
  }, {
    key: "name",
    get: function get() {
      return this.getAttributeNS(null, "name") || "";
    }
  }]);

  return HTMLSlotElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLSlotElementImpl
};